import { MouseEventHandler } from 'react'
import { Modal } from '../../../component/modal'
import { MediaFile } from '../../../entity'
import { createFormattedDateTimeString } from '../../../helper'
import { useTranslation } from 'react-i18next'
import './photo-info-modal.scss'

interface PhotoInfoModalProps {
    mediaFile: MediaFile
    onCloseClick?: MouseEventHandler
    onCancelClick?: MouseEventHandler
    onOkClick?: MouseEventHandler
}

export const PhotoInfoModal = (props: PhotoInfoModalProps) => {
    const { t } = useTranslation()

    return (
        <Modal title={t(props.mediaFile.type === 0 ? 'photo_info_modal_title' : 'video_info_modal_title') + ' ' + props.mediaFile.id} onCloseClick={props.onCloseClick} onCancelClick={props.onCancelClick} onOkClick={props.onOkClick}>
            <>
                <div className="photo-info-modal__row">
                    <label className="photo-info-modal__title">{t('photo_info_modal_reporter_title')}</label>
                    <label className="photo-info-modal__description">{props.mediaFile.sender?.firstName + ' ' + props.mediaFile.sender?.lastName}</label>
                </div>
                <div className="photo-info-modal__row">
                    <label className="photo-info-modal__title">{t(props.mediaFile.type === 0 ? 'photo_info_modal_taken_title' : 'photo_info_modal_video_taken_title')}</label>
                    <label className="photo-info-modal__description">{createFormattedDateTimeString(props.mediaFile.metadata?.mobileCreated ?? 0)}</label>
                </div>
                <div className="photo-info-modal__row">
                    <label className="photo-info-modal__title">{t('photo_info_modal_upload_title')}</label>
                    <label className="photo-info-modal__description">{createFormattedDateTimeString(props.mediaFile.created)}</label>
                </div>

                {props.mediaFile.metadata?.created!! - props.mediaFile.metadata?.mobileCreated!! > 600 ? (
                    <div className="photo-info-modal__row">
                        <label className="photo-info-modal__title"></label>
                        <label className="photo-info-modal__description">{t('warranty_card_offline')}</label>
                    </div>
                ) : null}

                <label className="photo-info-modal__description">{t('photo_info_modal_modification_title')}</label>
                <div className="photo-info-modal__row">
                    <label className="photo-info-modal__title">{t('photo_info_modal_modified_title')}</label>
                    <label className="photo-info-modal__description">{props.mediaFile.modifier?.firstName + ' ' + props.mediaFile.modifier?.lastName}</label>
                </div>
                <div className="photo-info-modal__row">
                    <label className="photo-info-modal__title">{t('photo_info_modal_modification_time_title')}</label>
                    <label className="photo-info-modal__description">{createFormattedDateTimeString(props.mediaFile.updated)}</label>
                </div>
            </>
        </Modal>
    )
}
